export const INCOMPLETE_TIME_WINDOW_SUFFIX = '-INCOMPLETE';
export const INCOMPLETE_START_SUFFIX = '-START';
export const INCOMPLETE_END_SUFFIX = '-END';

export interface GetPropertyNameForIncompleteTimeWindow {
  displayName: string;
  incompleteStartEndSuffix?:
    | typeof INCOMPLETE_START_SUFFIX
    | typeof INCOMPLETE_END_SUFFIX;
}

export const getPropertyNameForIncompleteTimeWindow = ({
  displayName,
  incompleteStartEndSuffix,
}: GetPropertyNameForIncompleteTimeWindow): string => {
  if (incompleteStartEndSuffix) {
    return `${displayName}${INCOMPLETE_TIME_WINDOW_SUFFIX}${incompleteStartEndSuffix}`;
  }
  return displayName;
};
